export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";